export default "__VITE_ASSET__BXtwYxOW__"